<script lang="ts">
	//Design system components
	import {
		Container,
		DeviceButton,
		DoubleDeviceButton,
		Icon,
		Radio,
		Text,
	} from '@Shelly/shelly-design-system';
	//Svelte hooks
	import { beforeUpdate, onMount } from 'svelte';
	//Services
	import { format } from 'svelte-i18n';

	export { className as class };
	export let editableObject;

	//####### Note: non calibrated trvs or those with disabled auto temperature control still uses degrees inside schedules
	let className = '';

	let value = editableObject?.brightness?.split('°')?.[0], //removing °C/F initially
		unit = editableObject.unit,
		isLoading = false,
		disabled = false,
		min = editableObject.min,
		max = editableObject.max,
		value_to_show = editableObject.brightness,
		selection =
			typeof editableObject.brightness === 'string' && editableObject.brightness.includes('lo')
				? editableObject._options[1]
				: typeof editableObject.brightness === 'string' &&
					  editableObject.brightness.includes('hi')
					? editableObject._options[0]
					: editableObject._options[2]; //_options[2] is brightness

	$: disabled = selection !== editableObject._options[2];

	onMount(() => {
		//maybe we have better way to do that but for now that's it
		if (value?.toString()?.includes('lo')) {
			value = min;
		}
		if (value.toString().includes('hi')) {
			value = max;
		}
	});
	beforeUpdate(() => {
		if (unit === 'C' && value <= 4) {
			value_to_show = 'Lo';
		} else if (unit === 'C' && value >= 31) {
			value_to_show = 'Hi';
		} else if (unit === 'C' && value === 5) {
			value_to_show = 'fas fa-snowflake';
		} else if (unit === 'F' && value <= 40) {
			value_to_show = 'Lo';
		} else if (unit === 'F' && value === 41) {
			value_to_show = 'fas fa-snowflake';
		} else if (value >= 87) {
			value_to_show = 'Hi';
		} else {
			value_to_show = value + '°' + unit;
		}
	});
	const changeAction = (e) => {
		selection = editableObject._options[editableObject.options.indexOf(e)];
		if (selection === editableObject._options[2]) {
			editableObject.selection = '0%';
		} else {
			editableObject.selection = e;
			editableObject.brightness = undefined;
		}
	};
	const changeTemperature = (n) => {
		if (value === 'lo') {
			value = min;
		}
		if (value === 'hi') {
			value = max;
		}

		value = Number(value);
		if (n === 0) {
			if (unit === 'F') {
				value -= 1;
			} else {
				if (value === 5) {
					value -= 1;
				} else {
					value -= 0.5;
					value = Number(value.toFixed(1));
				}
			}
		} else {
			if (unit === 'F') {
				value += 1;
			} else {
				if (value === 4) {
					value += 1;
				} else {
					value += 0.5;
					value = Number(value.toFixed(1));
				}
			}
		}
		if (value <= min) {
			value = min;
		}
		if (value >= max) {
			value = max;
		}
		selection = editableObject._options[2];
		editableObject.brightness = value;
	};
	/* time stuff */
	let timer;
	let interval;

	const handleLongPress = (e, val) => {
		e.preventDefault();
		e.stopPropagation();
		interval = setInterval(() => {
			changeTemperature(val);
		}, 100);
	};
</script>

<Container padding="scrollPaddings">
	<svelte:fragment>
		<Text class="mb-m" element="h2">
			{$format('select_type', {
				values: { type: $format('process_action') },
			})}
		</Text>

		{#each editableObject._options as option}
			<Radio
				bind:selected={selection}
				value={option}
				size="l"
				on:click={(e) => {
					changeAction(e.target.value);
				}}
				id="radio-ov6nn4l"
			>
				{option}
			</Radio>
		{/each}
	</svelte:fragment>
</Container>

<Container padding="scrollPaddings">
	<hr class="mt-l mb-l" />
	<Text class="mb-m" element="h2">
		{$format('scene_preview_when')}
		{$format(`option_t${unit}`)}
	</Text>
	<DoubleDeviceButton
		id="doubledevicebutton-odw6y4i"
		{isLoading}
		{disabled}
		class={className}
		aria-label={$format('button_group_temperature_change', {
			default: 'Handle temperature change ',
		})}
	>
		<DeviceButton
			id="devicebutton-6vjsctf"
			aria-label={$format('button_decrease_temperature', { default: 'Decrease temperature' })}
			{disabled}
			slot="buttonLeft"
			icon="fas fa-minus"
			on:click={(e) => changeTemperature(0)}
			on:touchLongpress={(e) => handleLongPress(e, 0)}
			on:touchend={() => clearInterval(interval)}
			on:mouseup={() => {
				clearInterval(interval);
			}}
		/>
		<svelte:fragment slot="content">
			{#if value_to_show.includes('fas')}
				<Icon icon={value_to_show} />
			{:else if value_to_show.includes('Hi') || value_to_show.includes('Lo')}
				<Text styleType="controls-large" class="text-bold">
					{value_to_show}
				</Text>
			{:else}
				<Text styleType="controls-large" class="text-bold">
					{value}
				</Text>

				<Text styleType="controls-small">{`°${unit}`}</Text>
			{/if}
		</svelte:fragment>
		<DeviceButton
			id="devicebutton-l9b9orr"
			aria-label={$format('button_increase_temperature', { default: 'Increase temperature' })}
			{disabled}
			slot="buttonRight"
			icon="fas fa-plus"
			variant="danger"
			on:click={(e) => changeTemperature(1)}
			on:touchLongpress={(e) => handleLongPress(e, 1)}
			on:touchend={() => clearInterval(interval)}
			on:mouseup={() => {
				clearInterval(interval);
			}}
		/>
	</DoubleDeviceButton>
</Container>
